var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShipmentViewLine = function SvgShipmentViewLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1151,
    height: 5,
    viewBox: "0 0 1151 5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117",
    transform: "translate(-414 -281)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1102",
    "data-name": "Rectangle 1102",
    width: 1083,
    height: 5,
    rx: 2.5,
    transform: "translate(414 281)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1103",
    "data-name": "Rectangle 1103",
    width: 43,
    height: 5,
    rx: 2.5,
    transform: "translate(1502 281)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1104",
    "data-name": "Rectangle 1104",
    width: 15,
    height: 5,
    rx: 2.5,
    transform: "translate(1550 281)",
    fill: "#2699fb"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShipmentViewLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shipmentViewLine.04cc9ccf.svg";
export { ForwardRef as ReactComponent };